// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"68":"b4f9ac6b","110":"07c2de4f","489":"400a1914","608":"26e7a825","840":"6c5014dc","977":"26508361"}[chunkId] + ".chunk.css";
};